// extracted by mini-css-extract-plugin
export default {"asTag":"ChipWithIcon_asTag__HlSMO","leftSide":"ChipWithIcon_leftSide__mJVnb","rightSide":"ChipWithIcon_rightSide__C62jk"};